import { useState } from 'react'
import {
  Space,
  Typography,
  Row,
  Col,
  Tooltip,
  Form,
  notification,
  Modal as ModalAntd,
  DatePicker,
  Radio,
} from 'antd'
import _ from 'lodash'
import { useAsync } from 'react-use'
import { useHistory } from 'react-router-dom'

import Page from 'components/Page'
import Card from 'components/Card'
import Button from 'components/Button'
import Table from 'components/Table'
import Modal from 'components/Modal'
import Select from 'components/Select'

import { useTranslate } from 'hooks/translate'
import { useStoreState } from 'easy-peasy'
import SearchOrganization from 'components/SearchOrganization'
import FilterReportStatusSelect from 'components/FilterReportStatusSelect'
import FilterReportTypeSelect from 'components/FilterReportTypeSelect'
import { updateUserByIdApi } from 'services/user'
import {
  getMyIncidentListApi,
  getMyIncidentTemplete,
  updateMergeMyIncidentApi,
  updateUnmergeMyIncidentApi,
  deleteMyIncidentByIdApi,
  importMyIncidentApi,
  updateSubmitMyIncidentApi,
  getRiskOwnerOrgFilterList,
  getUserFilterList,
} from 'services/myIncident'
import { getReportTypeFilterListApi } from 'services/filter/reportType'

import moment from 'moment'

import { DeleteOutlined, SettingOutlined } from '@ant-design/icons'
import Styled from './styled'
import { convertOrganizationalStructureToFilters } from 'utils/organization'
// import ActionPlan from './components/ActionPlan'

const DEFAULT_PAGE_SIZE = 10
const { RangePicker } = DatePicker

// export default function PageMyIncident() {
//   return (
//         <Styled className="page page-my-incident">
//           PageMyIncident
//           <ActionPlan
//             defaultAmountOfReturn={3}
//             reportHeaderId={7}
//           ></ActionPlan>
//         </Styled>
//   )
// }

export default function MyIncident () {
  const { t } = useTranslate()
  const history = useHistory()
  const { user_id } = JSON.parse(localStorage.user)
  const DATE_FORMAT = 'YYYY-MM-DD'
  const { incidentDashboardFilters } = useStoreState((store) => store.monthlyDashboard)

  const [showImportModal, setShowImportModal] = useState(false)
  const [currentDataSource, setCurrentDataSource] = useState([])
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [selectedCRowKeys, setSelectedCRowKeys] = useState({})
  const [selectedRowValue, setSelectedRowValue] = useState([])
  const [selectedCRowValue, setSelectedCRowValue] = useState({})
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [showUnmergeModal, setShowUnmergeModal] = useState(false)
  const [showMergeModal, setShowMergeModal] = useState(false)
  const [showReportTypeModal, setShowReportTypeModal] = useState(false)
  const [is_editable, setIsEditable] = useState('all')
  const [loading, setLoading] = useState(false)
  const [filters, setFilters] = useState({
    incident_topic: null,
    page: 1,
    size: DEFAULT_PAGE_SIZE,
  })
  const [total, setTotal] = useState(0)
  const [dataForUpdate, setDataForUpdate] = useState({})
  const [submitting, setSubmitting] = useState(false)
  const [reportTypeList, setReportTypeList] = useState([])
  const [RiskOwnerOrgList, setRiskOwnerOrgList] = useState([])
  const [reportList, setReporList] = useState([])
  const [reportTypeId, setReportTypeId] = useState(null)
  const [reportHeaderId, setReportHeaderId] = useState(null)
  const [deleting, setDeleting] = useState(false)
  const [file, setFile] = useState(null)
  const [filterValue, setFilterValue] = useState({})
  const is_riskAnalyst = JSON.parse(localStorage.getItem('user'))?.profile?.role_id === 4
  const user = JSON.parse(localStorage.getItem('user'))
  const [assigneeList, setAssigneeList] = useState([])
  const org = JSON.parse(localStorage.getItem('org'))

  const _list = async () => {
    if (loading) return

    let params = {
      date_from: moment().startOf('year').format(DATE_FORMAT),
      date_to: moment().format(DATE_FORMAT),
      ...filterValue,
      ...filters,
    }
    if (is_editable !== 'all') {
      params = {
        ...params,
        is_editable: is_editable === 'editable',
      }
    }
    setLoading(true)

    const res = await getMyIncidentListApi({ ...params, parent_only: true })

    setLoading(false)

    if (res.status === 'error') {
      notification.error({
        message: 'Failed',
        description: res.message,
      })

      return
    }

    setTotal(res.data?.total)
    setCurrentDataSource(res.data?.items)
    setReporList(
      res.data?.items?.map((item) => {
        return {
          value: item?.report_header_id,
          label: item?.incident_topic,
        }
      })
    )
  }

  const _delete = async (id) => {
    if (deleting) return

    setDeleting(true)

    const res = await deleteMyIncidentByIdApi(id)

    setDeleting(false)

    if (res.status === 'error') {
      notification.error({
        message: 'Failed',
        description: res.message,
      })

      return
    }

    _list()
  }

  const _submit = async () => {
    selectedRowKeys.map(async (v, i) => {
      const res = await updateSubmitMyIncidentApi({
        report_header_id: selectedRowKeys[i],
      })
      if (res.status === 'error') {
        notification.error({
          message: 'Failed',
          description: res.message,
        })

        return
      }
      return v
    })
    setSelectedCRowKeys({})
    setSelectedCRowValue({})
    setSelectedRowKeys([])
  }

  const _getTemplete = async () => {
    if (loading) return

    setLoading(true)

    const res = await getMyIncidentTemplete({ report_type_id: reportTypeId })
    setLoading(false)

    if (res.status === 'error') {
      notification.error({
        message: 'Failed',
        description: res.message,
      })

      return
    }
  }

  const getRiskOwnerOrgList = async (isReportOwnself) => {
    const reportListRiskOwnerOrg = await getRiskOwnerOrgFilterList()
    const formatReportListStatus = _.map(reportListRiskOwnerOrg?.data, (item) => {
      return { ...item, label: item.level_org_name, value: item.level_org_code }
    })
    setRiskOwnerOrgList(formatReportListStatus)
  }

  const getReportTypeList = async () => {
    const reportListType = await getReportTypeFilterListApi({ is_permission: true })
    const formatReportListType = _.map(reportListType?.data, (item) => {
      return { label: item.name, value: item.id }
    })
    setReportTypeList(formatReportListType)
  }

  const getAssigneeList = async () => {
    console.log('org', org, 'user', user)
    let roleID = user?.profile?.role_id
    let params = {}
    if ([1, 2, 8].includes(roleID)) {
      params = {
        user_id: user?.user_id,
      }
    } else if (roleID === 3) {
      params = {
        role_id: [1, 2, 3, 8],
        is_pool_org_code: org?.is_pool_org_code,
      }
    } else if (roleID === 6) {
      params = {
        role_id: [1, 2, 3, 6, 8],
        is_pool_org_code: org?.is_pool_org_code,
      }
    } else if (roleID === 7) {
      params = {
        is_pool_org_code: org?.is_pool_org_code,
      }
    }
    const res = await getUserFilterList({
      ...params,
    })
    if (res?.status === 'success' && res?.data) {
      let data = res?.data.map((item) => {
        return { ...item, label: item?.employee?.employee_name_th, value: item?.user_id }
      })
      setAssigneeList(data)
    }
  }

  useAsync(async () => {
    _list()
  }, [filters, filterValue, is_editable])

  useAsync(async () => {
    getReportTypeList()
    getRiskOwnerOrgList()
    getAssigneeList()
  }, [])

  const columns = [
    {
      title: t('Topic'),
      dataIndex: 'incident_topic',
      key: 'incident_topic',
      sorter: (a, b) => a?.incident_topic.localeCompare(b?.incident_topic),
      width: 250,
      render: (text, record, index) => {
        return <Typography.Text strong={record?.can_edit}>{text}</Typography.Text>
      },
    },
    {
      title: t('Report Code'),
      dataIndex: 'reportcode_cd',
      key: 'reportcode_cd',
      sorter: (a, b) => `${a?.reportcode_cd || ''}`.localeCompare(b?.reportcode_cd || ''),
      width: 200,
      render: (text, record, index) => {
        return <Typography.Text strong={record?.can_edit}>{text}</Typography.Text>
      },
    },
    {
      title: t('Reporter'),
      dataIndex: 'reporter',
      key: 'reporter',
      sorter: (a, b) => a.reporter.localeCompare(b.reporter),
      width: 200,
      render: (text, record, index) => {
        return <Typography.Text strong={record?.can_edit}>{text}</Typography.Text>
      },
    },
    {
      title: t('Report Date'),
      dataIndex: 'report_date',
      key: 'report_date',
      sorter: (a, b) => moment(a.report_date, 'YYYY-MM-DD') - moment(b.report_date, 'YYYY-MM-DD'),
      width: 120,
      render: (text, record, index) => {
        return (
          <Typography.Text strong={record?.can_edit}>
            {moment(text, 'YYYY-MM-DD').format('DD-MM-YYYY') || ''}
          </Typography.Text>
        )
      },
    },
    {
      title: t('Risk Coordinator'),
      dataIndex: 'riskcoordinator',
      key: 'riskcoordinator',
      sorter: (a, b) => {
        return `${a?.riskcoordinator?.employee?.employee_name_th || ''}`.localeCompare(
          b?.riskcoordinator?.employee?.employee_name_th || ''
        )
      },
      width: 150,
      render: (text, record, index) => {
        return (
          <Typography.Text strong={record?.can_edit}>
            {text?.employee?.employee_name_th || ''}
          </Typography.Text>
        )
      },
    },
    {
      title: t('Risk Owner'),
      dataIndex: 'risk_owner_org_name',
      key: 'risk_owner_org_name',
      sorter: (a, b) => a.risk_owner_org_name.localeCompare(b.risk_owner_org_name),
      width: 150,
      render: (text, record, index) => {
        return <Typography.Text strong={record?.can_edit}>{text}</Typography.Text>
      },
    },
    {
      title: t('Risk Analyst'),
      dataIndex: 'riskanalyst',
      key: 'riskanalyst',
      sorter: (a, b) => {
        return `${a?.riskanalyst?.employee?.employee_name_th || ''}`.localeCompare(
          b?.riskanalyst?.employee?.employee_name_th || ''
        )
      },
      width: 150,
      render: (text, record, index) => {
        return (
          <Typography.Text strong={record?.can_edit}>
            {text?.employee?.employee_name_th || ''}
          </Typography.Text>
        )
      },
    },
    {
      title: t('Report Type'),
      dataIndex: 'report_type',
      key: 'report_type',
      sorter: (a, b) => a.report_type.localeCompare(b.report_type),
      width: 150,
      render: (text, record, index) => {
        return <Typography.Text strong={record?.can_edit}>{text}</Typography.Text>
      },
    },
    {
      title: t('Relation'),
      dataIndex: 'relation',
      key: 'relation',
      width: 250,
      render: (text, record, index) => {
        return (
          <Space direction='vertical' style={{ width: 200 }}>
            {record?.report_header_parent?.map((p) => (
              <Typography.Text strong={record?.can_edit}>
                Parant : {p?.incident_topic || ''}
              </Typography.Text>
            ))}
            {record?.report_header_child?.map((c) => (
              <Typography.Text strong={record?.can_edit}>
                Child : {c?.incident_topic || ''}
              </Typography.Text>
            ))}
          </Space>
        )
      },
    },
    {
      title: t('Status'),
      dataIndex: 'status',
      key: 'status',
      width: 150,
      sorter: (a, b) => a.status.localeCompare(b.status),
      render: (text, record, index) => {
        return <Typography.Text strong={record?.can_edit}>{text}</Typography.Text>
      },
    },
    {
      title: t('AP Status'),
      dataIndex: 'ap_status',
      key: 'ap_status',
      sorter: (a, b) => a.ap_status.localeCompare(b.ap_status),
      width: 150,
      render: (text, record, index) => {
        return <Typography.Text strong={record?.can_edit}>{text}</Typography.Text>
      },
    },
    {
      title: t('Assignee'),
      dataIndex: 'assignee',
      key: 'assignee',
      width: 150,
      sorter: (a, b) => {
        return `${a?.assignee?.employee?.employee_name_th || ''}`.localeCompare(
          b?.assignee?.employee?.employee_name_th || ''
        )
      },
      render: (text, record, index) => {
        return (
          <Typography.Text strong={record?.can_edit}>
            {text?.employee?.employee_name_th || ''}
          </Typography.Text>
        )
      },
    },
    {
      title: t('Actions'),
      dataIndex: 'actions',
      key: 'actions',
      width: 150,
      render: (text, record, index) => {
        return (
          <Space size='small'>
            <Tooltip title={t('Edit')}>
              <Button
                type='link'
                onClick={() => {
                  console.log('====', record, record?.report_status_id, record?.report_header_id)
                  history.push(
                    `/incident-report/${record?.report_type_id}/${record?.report_header_id}`
                  )
                }}
                icon={<SettingOutlined />}
              />
            </Tooltip>
            <Tooltip title={t('Delete')}>
              {/* is_riskAnalyst */}
              <Button
                type='link'
                danger
                icon={<DeleteOutlined />}
                disabled={
                  record?.report_status_id === 1 && is_riskAnalyst ? false : !record?.can_delete
                }
                onClick={() => {
                  ModalAntd.confirm({
                    title: 'Confirm delete',
                    icon: null,
                    maskClosable: true,
                    closeIcon: true,
                    content: <div></div>,
                    okButtonProps: {
                      shape: 'round',
                    },
                    okText: 'Delete',
                    okType: 'primary',
                    cancelButtonProps: {
                      shape: 'round',
                    },
                    cancelText: 'Cancel',
                    onOk: async () => {
                      await _delete(record?.id)
                    },
                  })
                }}
              />
            </Tooltip>
          </Space>
        )
      },
    },
  ]

  const handleChange = (value) => {
    setReportTypeId(value)
  }
  const handleReportChange = (value) => {
    setReportHeaderId(value)
  }
  const handleChangeFile = (event) => {
    setFile(event.target.files[0])
  }
  const handleSubmit = (event) => {
    console.log('event', event)
    const reporter = [
      'reporter_company_id',
      'reporter_group_id',
      'reporter_bu_id',
      'reporter_division_id',
      'reporter_department_id',
      'reporter_section_id',
    ]
    const riskco = [
      'risk_co_company_id',
      'risk_co_group_id',
      'risk_co_bu_id',
      'risk_co_division_id',
      'risk_co_department_id',
      'risk_co_section_id',
    ]
    const riskowner = [
      'risk_owner_company_id',
      'risk_owner_group_id',
      'risk_owner_bu_id',
      'risk_owner_division_id',
      'risk_owner_department_id',
      'risk_owner_section_id',
    ]
    const reporterFilters = convertOrganizationalStructureToFilters(
      event.reporter_company_id,
      reporter
    )
    const riskcoFilters = convertOrganizationalStructureToFilters(event.risk_co_company_id, riskco)
    const riskownerFilters = convertOrganizationalStructureToFilters(
      event.risk_owner_company_id,
      riskowner
    )
    const [date_from, date_to] = event.date_from || []

    setFilterValue({
      ...filterValue,
      ...event,
      ...reporterFilters,
      ...riskcoFilters,
      ...riskownerFilters,
      date_from: date_from?.format(DATE_FORMAT),
      date_to: date_to?.format(DATE_FORMAT),
    })
  }
  return (
    <Styled className='page page-team-inciden'>
      <Page
        title={t('Team Incident')}
        searchPlaceholder={t('Search Topic / Report Code')}
        onSearch={(value) => {
          setFilters({
            ...filters,
            incident_topic: value,
            page: 1,
          })
        }}
        onBlur={(v) => {
          setFilters({
            ...filters,
            incident_topic: v,
            page: 1,
          })
        }}
      >
        <Space size='middle' direction='vertical' style={{ width: '100%' }}>
          <Row justify='space-between'>
            <Col></Col>
            <Col>
              <Row justify='space-between'>
                <Col>
                  <Button
                    // type='primary'
                    disabled={
                      !['Central Reporter', 'Risk Analyst'].includes(user?.profile?.role?.role_name)
                    }
                    size='large'
                    onClick={() => setShowImportModal(true)}
                  >
                    {t('Import Excel')}
                  </Button>
                </Col>
                <Col>
                  {' '}
                  <Button type='primary' size='large' onClick={() => setShowReportTypeModal(true)}>
                    {t('New Incident Report')}
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
          <Form
            layout='horizontal'
            colon={false}
            initialValues={{
              // reporter_company_id: incidentDashboardFilters?.reporter_company_id,
              // risk_co_company_id: incidentDashboardFilters?.risk_co_company_id,
              // risk_owner_company_id: incidentDashboardFilters?.risk_owner_company_id,
              // report_status_id: incidentDashboardFilters?.report_status_id,
              // report_type_id: incidentDashboardFilters?.report_type_id,
              date_from: [
                // incidentDashboardFilters?.date_from
                //   ? moment(incidentDashboardFilters?.date_from)
                //   :
                moment().startOf('year'),
                // incidentDashboardFilters?.date_to
                //   ? moment(incidentDashboardFilters?.date_to)
                //   :
                moment(),
              ],
            }}
            name='search'
            onFinish={handleSubmit}
          >
            <Row gutter={8}>
              <Col span={22}>
                <Row gutter={8}>
                  <Col xs={24} lg={12}>
                    <Form.Item labelCol={{ span: 4 }} name='reporter_company_id' label='Reporter'>
                      <SearchOrganization />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={12}>
                    <Form.Item name='risk_co_company_id' label='Risk Co'>
                      <SearchOrganization />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={8}>
                  <Col xs={24} lg={12}>
                    <Form.Item name='risk_owner_org' labelCol={{ span: 4 }} label='Risk Owner'>
                      <Select options={RiskOwnerOrgList} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={12}>
                    <Form.Item name='date_from' label='Report From - to'>
                      <RangePicker allowClear={false} format={DATE_FORMAT} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={8}>
                  <Col xs={24} lg={12}>
                    <Form.Item name='report_type_id' labelCol={{ span: 4 }} label='Report Type'>
                      <FilterReportTypeSelect att={{ mode: 'multiple' }} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={4}>
                    <Form.Item name='report_status_id'>
                      <FilterReportStatusSelect att={{ mode: 'multiple' }} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <Form.Item name='assignee_id' labelCol={{ span: 4 }} label='Assignee'>
                      <Select options={assigneeList} />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col xs={24} lg={2}>
                <Button type='primary' htmlType='submit'>
                  {t('Search')}
                </Button>
              </Col>
            </Row>
          </Form>
          <Card
            title={t('Incident Report')}
            // titleExtra={
            //   // editMode ? (
            //   <Row gutter={[10, 10]}>
            //     <Col xs={24} lg={12}>
            //       <Button
            //         type='primary'
            //         // onClick={async () => {
            //         //   const res = await updateMergeMyIncidentApi({
            //         //     report_header_id: selectedRowKeys,
            //         //   })
            //         //   if (res.status === 'error') {
            //         //     notification.error({
            //         //       message: 'Failed',
            //         //       description: res.message,
            //         //     })

            //         //     return
            //         //   }
            //         //   setSelectedRowKeys([])
            //         // }}
            //         onClick={() => setShowMergeModal(true)}
            //         disabled={!selectedRowKeys.length > 0 || !is_riskAnalyst}
            //       >
            //         {t('Merge Incident')}
            //       </Button>
            //     </Col>
            //     <Col xs={24} lg={12}>
            //       <Button
            //         type='primary'
            //         disabled={selectedRowKeys.length !== 1 || !is_riskAnalyst}
            //         onClick={() => setShowUnmergeModal(true)}
            //       >
            //         {t('Unmerge Incident')}
            //       </Button>
            //     </Col>
            //   </Row>
            // }
            // extra={
            //   <Space>
            //     <Button
            //       type='primary'
            //       disabled={selectedRowKeys.length === 0}
            //       // onClick={() => setShowUnmergeModal(true)}
            //       onClick={async () => {
            //         ModalAntd.confirm({
            //           title: 'Confirm submit',
            //           icon: null,
            //           maskClosable: true,
            //           closeIcon: true,
            //           content: <div></div>,
            //           okButtonProps: {
            //             shape: 'round',
            //           },
            //           okText: 'Submit',
            //           okType: 'primary',
            //           cancelButtonProps: {
            //             shape: 'round',
            //           },
            //           cancelText: 'Cancel',
            //           onOk: async () => {
            //             await _submit()
            //           },
            //         })
            //       }}
            //     >
            //       {t('Submit Selection')}
            //     </Button>
            //     <Radio.Group
            //       value={is_editable}
            //       onChange={(value) => {
            //         return setIsEditable(value?.target?.value)
            //       }}
            //       options={[
            //         { label: t('All'), value: 'all' },
            //         { label: t('Editable'), value: 'editable' },
            //         { label: t('Viewable'), value: 'viewable' },
            //       ]}
            //       defaultValue='all'
            //       optionType='button'
            //       buttonStyle='solid'
            //     />
            //   </Space>
            // }
          >
            <Row justify='space-between' gutter={[0, 6]}>
              <Col>
                <Row gutter={[55, 6]} justify='space-around'>
                  <Col xs={24} sm={4} lg={7} style={{ paddingLeft: 10 }}>
                    <Button
                      type='primary'
                      onClick={() => setShowMergeModal(true)}
                      disabled={!selectedRowKeys.length > 0 || !is_riskAnalyst}
                    >
                      {t('Merge Incident')}
                    </Button>
                  </Col>
                  <Col xs={24} sm={5} lg={8} style={{ paddingLeft: 10 }}>
                    <Button
                      type='primary'
                      disabled={selectedRowKeys.length !== 1 || !is_riskAnalyst}
                      onClick={() => setShowUnmergeModal(true)}
                    >
                      {t('Unmerge Incident')}
                    </Button>
                  </Col>
                  <Col xs={24} sm={5} lg={8} style={{ paddingLeft: 10 }}>
                    <Button
                      type='primary'
                      disabled={selectedRowKeys.length === 0}
                      // onClick={() => setShowUnmergeModal(true)}
                      onClick={async () => {
                        ModalAntd.confirm({
                          title: 'Confirm submit',
                          icon: null,
                          maskClosable: true,
                          closeIcon: true,
                          content: <div></div>,
                          okButtonProps: {
                            shape: 'round',
                          },
                          okText: 'Submit',
                          okType: 'primary',
                          cancelButtonProps: {
                            shape: 'round',
                          },
                          cancelText: 'Cancel',
                          onOk: async () => {
                            await _submit()
                          },
                        })
                      }}
                    >
                      {t('Submit Selection')}
                    </Button>
                  </Col>
                </Row>
              </Col>
              <Col xs={20} sm={17} lg={5}>
                <Radio.Group
                  value={is_editable}
                  onChange={(value) => {
                    return setIsEditable(value?.target?.value)
                  }}
                  options={[
                    { label: t('All'), value: 'all' },
                    { label: t('Editable'), value: 'editable' },
                    { label: t('Viewable'), value: 'viewable' },
                  ]}
                  defaultValue='all'
                  optionType='button'
                  buttonStyle='solid'
                />
              </Col>
            </Row>

            <Table
              loading={loading}
              rowSelection={{
                selectedRowKeys: selectedCRowKeys[filters.page],
                onChange: (key, value) => {
                  setSelectedCRowKeys((v) => {
                    let valueArray = []
                    Object.values({ ...v, [filters.page]: key }).map((item) => {
                      valueArray = [...valueArray, ...item]
                      return item
                    })
                    setSelectedRowKeys(valueArray)

                    return { ...v, [filters.page]: key }
                  })
                  setSelectedCRowValue((v) => {
                    let valueArray = []
                    Object.values({ ...v, [filters.page]: value }).map((item) => {
                      valueArray = [...valueArray, ...item]
                      return item
                    })
                    setSelectedRowValue(valueArray)
                    return { ...v, [filters.page]: value }
                  })
                },
                getCheckboxProps: (record) => {
                  return {
                    disabled: record?.report_header_parent.length !== 0 || !record?.can_edit,
                  }
                },
              }}
              columns={columns}
              dataSource={currentDataSource}
              pagination={{
                current: filters.page,
                pageSize: filters.size,
                total,
                showQuickJumper: true,
                showSizeChanger: true,
                showTotal: (total) => t('Total ${total} items', { total }),
              }}
              onChange={(pagination, filterss, sorter) => {
                setFilters({
                  ...filterss,
                  page: pagination.current,
                  size: pagination.pageSize,
                })
                console.log('sorter', sorter)
              }}
              scroll={{ x: 1200 }}
              sticky
            />
          </Card>
        </Space>
      </Page>
      <Modal
        width={800}
        visible={showImportModal}
        title={t('Import Report')}
        onCancel={() => {
          setShowImportModal(false)
        }}
        footer={[
          <Button
            loading={submitting}
            key='save'
            type='primary'
            disabled={!file}
            onClick={async () => {
              if (submitting) return

              setSubmitting(true)
              await importMyIncidentApi({
                file,
                report_type_id: reportTypeId,
              })
              setSubmitting(false)
              setFile(null)
              _list()
              setShowImportModal(false)
            }}
          >
            {t('Import')}
          </Button>,
        ]}
      >
        <div>
          <Space direction='vertical' size='large' style={{ width: '100%' }}>
            <Col xs={24}>
              <Select
                placeholder={t('Select Report Type')}
                onChange={handleChange}
                options={reportTypeList}
                style={{ width: '100%' }}
              />
            </Col>
            <Button
              // type='primary'
              // size='large'
              onClick={() => _getTemplete()}
              disabled={!reportTypeId}
            >
              {t('Export Templete')}
            </Button>
            <input type='file' id='file' name='file' multiple onChange={handleChangeFile}></input>
          </Space>
        </div>
      </Modal>

      <Modal
        visible={showConfirmModal}
        title={t('Confirm changes')}
        onCancel={() => {
          setShowConfirmModal(false)
        }}
        footer={[
          <Button
            loading={submitting}
            key='save'
            type='primary'
            onClick={async () => {
              if (submitting) return

              setSubmitting(true)

              await Promise.all(
                _.map(dataForUpdate, async (v) => {
                  const res = await updateUserByIdApi({
                    user_id: v.user_id,
                    profile_id: v.profile_id,
                  })

                  if (res.status === 'error') {
                    notification.error({
                      message: 'Failed',
                      description: res.message,
                    })

                    return
                  }

                  return res
                })
              )

              setSubmitting(false)

              _list()

              setShowConfirmModal(false)
              setDataForUpdate({})
            }}
          >
            {t('Save')}
          </Button>,
        ]}
      ></Modal>

      <Modal
        visible={showUnmergeModal}
        title={t('Unmerge Incident')}
        onCancel={() => {
          setShowUnmergeModal(false)
        }}
        footer={[
          <Button
            loading={submitting}
            key='save'
            type='primary'
            onClick={async () => {
              if (submitting) return

              setSubmitting(true)

              const res = await updateUnmergeMyIncidentApi({
                report_header_id: selectedRowKeys,
              })
              if (res.status === 'error') {
                notification.error({
                  message: 'Failed',
                  description: res.message,
                })

                return
              }
              setSelectedCRowKeys({})
              setSelectedCRowValue({})
              setSelectedRowKeys([])

              setSubmitting(false)

              _list()

              setShowUnmergeModal(false)
              setDataForUpdate({})
            }}
          >
            {t('Save')}
          </Button>,
        ]}
      >
        <div>
          <Space direction='vertical' size='large' style={{ width: '100%' }}>
            <Col>
              <Space size='middle'>Parent Incident:</Space>
            </Col>
            <Col>
              {currentDataSource.find((i) => i?.report_header_id === selectedRowKeys[0])
                ?.incident_topic || ''}
            </Col>
            <Col>
              <Space size='middle'>Child Incident:</Space>
            </Col>
            {currentDataSource
              .find((i) => i?.report_header_id === selectedRowKeys[0])
              ?.report_header_child.map((i) => <Col>{i?.incident_topic || ''}</Col>) || ''}
          </Space>
        </div>
      </Modal>

      <Modal
        visible={showMergeModal}
        title={t('Merge Incident')}
        onCancel={() => {
          setShowMergeModal(false)
        }}
        footer={[
          <Button
            loading={submitting}
            key='save'
            type='primary'
            disabled={!reportHeaderId}
            onClick={async () => {
              if (submitting) return

              setSubmitting(true)

              const res = await updateMergeMyIncidentApi({
                report_header_id: selectedRowKeys.filter((i) => i !== reportHeaderId),
                reportHeaderId: reportHeaderId,
              })
              if (res.status === 'error') {
                notification.error({
                  message: 'Failed',
                  description: res.message,
                })

                return
              }
              setSelectedCRowKeys({})
              setSelectedCRowValue({})
              setSelectedRowKeys([])

              setSubmitting(false)

              _list()

              setShowMergeModal(false)
              setDataForUpdate({})
              setReportHeaderId(null)
            }}
          >
            {t('Save')}
          </Button>,
        ]}
      >
        <div>
          <Space direction='vertical' size='large' style={{ width: '100%' }}>
            <Col>
              <Space size='middle'>Merge From:</Space>
            </Col>
            {selectedRowValue
              .filter((item) => item?.report_header_id !== reportHeaderId)
              ?.map((id) => <Col>{id?.incident_topic || ''}</Col>) || ''}
            <Col>
              <Space size='middle'>Merge into:</Space>
            </Col>
            <Col>
              <Select
                placeholder={t('Select Report')}
                onChange={handleReportChange}
                value={reportHeaderId}
                options={selectedRowValue?.map((item) => {
                  return { ...item, label: item?.incident_topic, value: item?.report_header_id }
                })}
              />
              {/* reportHeaderId */}
            </Col>
            {/* <Col>
              {currentDataSource.find((i) => i?.report_header_id === selectedRowKeys[0])
                ?.incident_topic || ''}
            </Col>
            <Col>
              <Space size='middle'>Child Incident:</Space>
            </Col>
            {currentDataSource
              .find((i) => i?.report_header_id === selectedRowKeys[0])
              ?.report_header_child.map((i) => <Col>{i?.incident_topic || ''}</Col>) || ''} */}
          </Space>
        </div>
      </Modal>

      <Modal
        visible={showReportTypeModal}
        title={t('Select Report Type')}
        onCancel={() => {
          setShowReportTypeModal(false)
        }}
        footer={[
          <Button
            loading={submitting}
            key='save'
            type='primary'
            disabled={!reportTypeId}
            onClick={async () => {
              history.push(`/incident-report/${reportTypeId}`)
            }}
          >
            {t('Create')}
          </Button>,
        ]}
      >
        <div>
          <Space direction='vertical' size='large' style={{ width: '100%' }}>
            <Col>
              <Space size='middle'>Select Available Report Type:</Space>
            </Col>
            <Col xs={24}>
              <Select
                placeholder={t('Select Report Type')}
                onChange={handleChange}
                options={reportTypeList}
                style={{ width: '100%' }}
              />
            </Col>
          </Space>
        </div>
      </Modal>
    </Styled>
  )
}
